export function component(options: {
    controllerAs?: string;
    bindings?: any;
    template?: string;
    templateCacheUrl?: string;
    transclude?: any;
    require?: any;
    controller: any;
}) {
    const obj = {
        ...options,
    } as any;

    obj["templateUrl"] = options.templateCacheUrl;

    return obj;
}
